import classNames from 'classnames'
import { type MenuOption } from '@opallabs/concepts'
import { singleSelectClasses } from '../componentClassNames'
import { SingleSelectContext } from '../contexts'
import { BodyProps } from '../types'
import * as styles from './styles'

type UnwrappedValue<T> = T extends MenuOption<infer V> ? V : never

type SingleSelectProps = BodyProps & {
  className?: string
}

export const Body = <
  Option extends MenuOption<OptionValue>,
  OptionValue extends string | number | boolean = UnwrappedValue<Option>,
>({
  children,
  className,
  clearInvalidSelection,
  externalRef,
  initialIsOpen,
  isClearable,
  onBlur,
  onOpenChange,
  shouldStayOpenOnSelect,
}: SingleSelectProps) => {
  return (
    <SingleSelectContext.StateProvider<Option, OptionValue>
      clearInvalidSelection={clearInvalidSelection}
      externalRef={externalRef}
      initialIsOpen={initialIsOpen}
      isClearable={isClearable}
      onBlur={onBlur}
      onOpenChange={onOpenChange}
      shouldStayOpenOnSelect={shouldStayOpenOnSelect}
    >
      <div
        css={styles.inputWrapper}
        className={classNames(singleSelectClasses.root, className)}
      >
        {children}
      </div>
    </SingleSelectContext.StateProvider>
  )
}
Body.displayName = 'Lapidary: Body ← SingleSelect'

export const SearchableBody = <
  Option extends MenuOption<OptionValue>,
  OptionValue extends string | number | boolean = UnwrappedValue<Option>,
>({
  children,
  className,
  clearInvalidSelection,
  externalRef,
  hideFooterOnSearch,
  initialIsOpen,
  isClearable,
  onBlur,
  onOpenChange,
}: SingleSelectProps) => {
  return (
    <SingleSelectContext.SearchProvider>
      <Body
        className={className}
        clearInvalidSelection={clearInvalidSelection}
        externalRef={externalRef}
        hideFooterOnSearch={hideFooterOnSearch}
        initialIsOpen={initialIsOpen}
        isClearable={isClearable}
        onBlur={onBlur}
        onOpenChange={onOpenChange}
      >
        {children}
      </Body>
    </SingleSelectContext.SearchProvider>
  )
}
SearchableBody.displayName = 'Lapidary: SearchableBody ← SingleSelect'
